import Handler from "../Handler";

class TourneyLateRegEndedHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTourneyLateRegistrationEnded(receivedData);
  }
}
export default TourneyLateRegEndedHandler;
